import React from "react";
import Tooltip from '@mui/material/Tooltip';
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";

function Item({ label, tooltip = false, bold = false, dollar = false, percent = false, currentCompanyBizminerRatios }) {
  return (
    <div className="flex items-center mt-3">
      <div
        className={
          bold
            ? "whitespace-nowrap flex items-center pt-4 pb-2 font-semibold border-t"
            : "whitespace-nowrap flex items-center pt-2"
        }
        style={{ minWidth: "22em" }}
      >
        {tooltip ? <Tooltip title = {tooltip} arrow>{label}</Tooltip> : label}
      </div>
      <div
        className={
          bold
            ? "flex pt-4 pb-2 font-semibold border-t"
            : "flex pt-2"
        }
      >
        {currentCompanyBizminerRatios["yearly" + label.replace(/[ ,:'-/]/g, "")]?.map((obj) => (
          <div className="flex" style={{ minWidth: "10em" }}>
            <div style={{ minWidth: "1.3em" }} />
              {CurrencyFormatter.format(percent ? obj.value * 100 : obj.value, {
                code: dollar ? "USD" : "",
              })}
              {percent ? "%" : ""}
          </div>
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyBizminerRatios: state.financialRatios.currentCompanyBizminerRatios
});

export default connect(mapStateToProps)(Item);
